import type { RecordView } from '@kit/sync/types/record-view';
import { useLiveQuery } from 'dexie-react-hooks';
import { replica } from '@/shared/sync/replica';
import type { CollectionName } from './collection-name';

/** One live record: undefined while loading, null when missing or in another collection. */
export function useRecord<T>(
  collection: CollectionName,
  id: string | undefined,
): RecordView<T> | null | undefined {
  return useLiveQuery(
    async function load() {
      if (!id) return null;
      const view = await replica.get(id);
      // Validated on write, like useRecords.
      return view && view.collection === collection ? (view as RecordView<T>) : null;
    },
    [collection, id],
  );
}
